module.exports = __webpack_public_path__ + "images/search-icon.svg";